import { memo } from 'react';
import { COLORS, SHADOWS } from '@/game/configs';
import { playSound, triggerHaptic } from '@/utils/soundManager';
import { Pencil, Undo2, Delete } from 'lucide-react';
interface NumberPadProps {
  notesMode: boolean;
  onNumberPress: (num: number) => void;
  onToggleNotes: () => void;
  onErase: () => void;
  onUndo: () => void;
}
export const NumberPad = memo(function NumberPad({
  notesMode,
  onNumberPress,
  onToggleNotes,
  onErase,
  onUndo,
}: NumberPadProps) {
  const handleNumberPress = (num: number) => {
    playSound('select');
    triggerHaptic();
    onNumberPress(num);
  };
  const handleToggleNotes = () => {
    playSound('select');
    triggerHaptic();
    onToggleNotes();
  };
  const handleErase = () => {
    playSound('erase');
    triggerHaptic();
    onErase();
  };
  const handleUndo = () => {
    playSound('select');
    triggerHaptic();
    onUndo();
  };
  const NumberButton = ({ num }: { num: number }) => (
    <button
      onClick={() => handleNumberPress(num)}
      className="flex items-center justify-center rounded-xl transition-all duration-100 active:scale-95 w-12 h-12 sm:w-14 sm:h-14"
      style={{
        backgroundColor: COLORS.cream,
        boxShadow: SHADOWS.soft,
      }}
    >
      <span
        className="text-lg sm:text-xl font-bold"
        style={{ color: COLORS.dark }}
      >
        {num}
      </span>
    </button>
  );
  return (
    <div
      className="w-full max-w-[360px] mx-auto px-2"
      style={{
        backgroundColor: COLORS.ivory,
        borderRadius: '24px',
        padding: '16px 8px',
      }}
    >
      <div className="flex flex-col gap-2 sm:gap-3">
        <div className="flex justify-center gap-2 sm:gap-3">
          {[1, 2, 3, 4, 5].map((num) => (
            <NumberButton key={num} num={num} />
          ))}
        </div>
        <div className="flex justify-center gap-2 sm:gap-3">
          {[6, 7, 8, 9].map((num) => (
            <NumberButton key={num} num={num} />
          ))}
          <button
            onClick={handleToggleNotes}
            className="flex items-center justify-center rounded-xl transition-all duration-100 active:scale-95 w-12 h-12 sm:w-14 sm:h-14"
            style={{
              backgroundColor: notesMode ? COLORS.yellow : COLORS.cream,
              boxShadow: SHADOWS.soft,
            }}
          >
            <Pencil
              size={22}
              style={{ color: notesMode ? COLORS.dark : COLORS.brown }}
            />
          </button>
        </div>
        <div className="flex justify-center gap-2 sm:gap-3">
          <button
            onClick={handleUndo}
            className="flex items-center justify-center rounded-xl transition-all duration-100 active:scale-95 w-12 h-12 sm:w-14 sm:h-14"
            style={{
              backgroundColor: COLORS.cream,
              boxShadow: SHADOWS.soft,
            }}
          >
            <Undo2
              size={22}
              style={{ color: COLORS.brown }}
            />
          </button>
          <button
            onClick={handleErase}
            className="flex items-center justify-center rounded-xl transition-all duration-100 active:scale-95 w-12 h-12 sm:w-14 sm:h-14"
            style={{
              backgroundColor: COLORS.cream,
              boxShadow: SHADOWS.soft,
            }}
          >
            <Delete
              size={22}
              style={{ color: COLORS.brown }}
            />
          </button>
        </div>
      </div>
    </div>
  );
});